import { Typography, Box } from '@mui/material';
import Colors from 'constants/colors';

interface DetailItemTypes {
    label?: string;
    value: string | number;
    labelWidth?: string | number;
    textAlign?: string;
    fontWeight?: string | number;
}

const DetailItem: React.FC<DetailItemTypes> = ({ label, value, labelWidth, textAlign = 'left', fontWeight = 'bold' }) => (
    <Box sx={{ my: 1 }}>
        <Typography sx={{ display: 'flex', flexDirection: 'row' }} variant="body1">
            <Typography
                sx={{
                    width: labelWidth || '30%',
                    color: Colors.darkTextColor,
                    fontSize: { xs: 12, sm: 14 },
                    fontWeight: '400',
                    '@media (max-width: 600px)': { width: '100%' },
                }}
                component="span"
            >
                {label && label + ':'}
            </Typography>
            <Typography
                sx={{
                    textAlign: textAlign || 'right',
                    width: '70%',
                    fontWeight: fontWeight,
                    color: Colors.darkTextColor,
                    fontSize: { xs: 10, sm: 14 },
                }}
                component="span"
            >
                {value}
            </Typography>
        </Typography>
    </Box>
);

export default DetailItem;
